import { CategoryResponseDto } from '@bitecritic-api/src/categories/dto/category.response.dto';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import categoriesService from '~/services/categoriesService/categories.service';

export const CATEGORIES_QUERY_KEY = 'categories';

export function useCategories() {
  const router = useRouter();
  const { locale } = router;
  const language = locale || 'en-US';

  const {
    data: categories,
    isLoading,
    error,
  } = useQuery<CategoryResponseDto[]>({
    queryKey: [CATEGORIES_QUERY_KEY, language],
    queryFn: () => categoriesService.fetchCategories(language),
  });

  return {
    categories: categories || [],
    isLoading,
    error,
  };
}

export default useCategories;
